import { FC, useCallback } from 'react';
import SkeletonBlock from 'src/common/components/SkeletonLoader/SkeletonBlock';
import TripCartSummaryHeader from 'src/trip-cart/components/drawer/TripCartSummaryHeader';
import TripCartBookingButtons from 'src/trip-cart/components/TripCartBookingButtons';
import { useTripCartOptionsContext } from 'src/trip-cart/hooks/useTripCartOptionsContext';
import { useTripCartContext } from 'src/trip-cart/hooks/useTripCartContext';
import { useTranslation } from 'next-i18next';
import { TRIP_CART_PANEL_ROOT } from 'src/listing/constants';
import SnoozeStatus from 'src/listing/components/SnoozeStatus';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import styles from './TripCartSummary.module.scss';

const TripCartSummary: FC = () => {
  const [t] = useTranslation('common');
  const { priceLoading } = useTripCartOptionsContext();
  const { showPanel, snoozeActive, listing } = useTripCartContext();

  const open = useCallback(() => {
    showPanel(TRIP_CART_PANEL_ROOT);
  }, [showPanel]);

  if (snoozeActive) {
    return (
      <div className={getClassNames(styles, 'root', classNames({ snooze: snoozeActive }))}>
        <SnoozeStatus
          reason={listing.snooze_reason as string}
          endDate={listing.snooze_end_date as string}
          snoozeActive={snoozeActive}
          variant="drawer"
        />
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <button
        type="button"
        className={styles.toggleButton}
        aria-label={t('bottom-drawer--open')}
        onPointerDown={open}
      />
      <div className={styles.summary}>
        <TripCartSummaryHeader />
      </div>
      <SkeletonBlock loading={priceLoading}>
        <TripCartBookingButtons
          position="trip-cart-bottom-sheet--closed"
          overrideClick={open}
        />
      </SkeletonBlock>
    </div>
  );
};
export default TripCartSummary;
